import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { checkSuperAdminSession } from "../../auth/superAdminUtils";
import { DEFAULT_HOME_ROUTE } from "../../auth/userTypeUtils";
import Spinner from "../spin/Spin";

const RequireSuperAdmin = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    checkSuperAdminSession().then((isSuperAdmin) => {
      if (cancelled) return;
      setAllowed(isSuperAdmin);
      setReady(true);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) return <Spinner />;

  if (!allowed) {
    return <Navigate to={DEFAULT_HOME_ROUTE} replace />;
  }

  return children;
};

export default RequireSuperAdmin;
